import React, {Component} from 'react';

class Tag extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(evt) {
    evt.preventDefault();
    evt.stopPropagation();

    this.props.removeToken(this.props.token);
  }

  render() {
    return (
      <div className="rt-cell">
        <p className="rt-cell__content">{this.props.textContent}</p>
        <span className="rt-cell__delete"
              onClick={this.handleClick}><i className="glyphicon glyphicon-remove"></i></span>
      </div>

    );
  }

}

Tag.propTypes = {
  removeToken: React.PropTypes.func,
  textContent: React.PropTypes.node,
  token: React.PropTypes.string,
};

export default Tag;



/** WEBPACK FOOTER **
 ** ./src/modules/search/components/Tag.js
 **/